import { TextInput, SelectInput, required } from 'react-admin';
import { DefaultToolbar } from '@/components/toolbars';
import { path } from '@/pages/AdverseAction/constants';
import { DISPUTE_CHOICES } from './constants';
import { AdverseEditDisputeProps } from '../types';
import useController from './useController';

/**
 * Form fields must be its own component so useFormContext can access fields values
 * react-admin creates the react-hook-form context in <SimpleForm>,
 * so useFormContext() cannot be used in the same component.
 */
const FormContent = (props: AdverseEditDisputeProps) => {
  const { handleClose, handleSave } = useController(props);

  return (
    <>
      <SelectInput source={path('adverse.dispute')} choices={DISPUTE_CHOICES} label="Dispute?" validate={required()} />
      <TextInput source={path('adverse.comments')} label="Comments" validate={required()} />

      <DefaultToolbar onClose={handleClose} onSave={handleSave} />
    </>
  );
};

export default FormContent;
